import React from 'react';
import { Button as ChButton, forwardRef, IconButton } from "@chakra-ui/react";

import Link from './Link'

const Button = forwardRef(({ href, to, trackerName, onClick, ...props }, ref) => {
  const handleTrackEvent = (e) => {
    if (onClick) {
      onClick(e)
    }
    if (trackerName && typeof window.gtag === 'function') {
      window.gtag("event", "click_button", {
        button_name: trackerName,
      });
    }
  }
  if ((href || to) && !props.isDisabled) return <ChButton ref={ref} href={href} to={to} as={Link} onClick={handleTrackEvent} {...props} />
  return <ChButton onClick={handleTrackEvent} {...props} ref={ref} />
})

Button.defaultProps = {
  // colorScheme: 'primary',
}

export default Button
